import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Vehicle} from '@ox/typings';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {Observable} from 'rxjs';
import {AppConfigService} from '@ox/utils';

@Component({
  selector: 'ox-vehicle-picker',
  templateUrl: './vehicle-picker.component.html'
})

export class VehiclePickerComponent {
  private _target = {
    GARAGE: '../garage',
    MYACCOUNT: this.appConfig.settings.moduleConfig.myAccountUrl(this.appConfig.bml.brand, this.appConfig.bml.lang)
  };

  public hasLocaleNames = this.appConfig.appSettings.moduleConfig.hasLocaleNames ? true : false;

  @Input() garage: Vehicle[] = [];
  @Input() activeVehicle$: Observable<Vehicle | undefined>;
  @Output() selectedVehicle = new EventEmitter();
  @Input() isModalClosable = false;

  targetHref = this.appConfig.settings.moduleConfig.navigateToMyAccount ? this._target.MYACCOUNT : this._target.GARAGE;

  constructor(
    public modalRef: BsModalRef,
    public appConfig: AppConfigService
  ) {}

  setActiveVehicleInGarage(vehicle: Vehicle) {
    this.selectedVehicle.emit(vehicle);
  }
}
